import classes from "./Dashboard.module.css";
import logo from "../../store/logo.png"
import {
    Button,
    Divider,
    IconButton,
    Tooltip,
    useMediaQuery,
    useTheme
} from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import {useState, useEffect} from "react";
import axios from "axios";
import {path} from "../../routes";
import Menu from "./Menu/Menu";
import SpecOffer from "./SpecOffer/SpecOffer";
import Users from "./Users/Users";
import UsersDisplays from "./UsersDisplays/UsersDisplays";
import ModalView from "./Modal/ModalView";
import Calendar from "./Calendar/Calendar";
import Vienna_slide from "./Vienna/Vienna_slide";
import Diplomat_slide from "./Diplomat/Diplomat_slide";
import Vienna_explore from "./Vienna/Vienna_explore";
import Vienna_text from "./Vienna/Vienna_text";
import LiveCameras from "./LiveCameras/LiveCameras";

const Dashboard = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Map tab numbers to URL-friendly names
    const tabToUrl = {
        0: 'menu-screen',
        1: 'kiosk-slideshow',
        2: 'meeting-rooms',
        3: 'vienna-slide',
        4: 'slideshow',
        5: 'users-displays',
        6: 'explore',
        7: 'text-edit',
        8: 'live-cameras'
    };

    const urlToTab = {
        'menu-screen': 0,
        'kiosk-slideshow': 1,
        'meeting-rooms': 2,
        'vienna-slide': 3,
        'diplomat-slideshow': 4,
        'slideshow': 4, // tab 4 používá #slideshow
        'users-displays': 5,
        'explore': 6,
        'text-edit': 7,
        'live-cameras': 8
    };

    // Initialize tab from URL or default to 2 (Meeting rooms)
    const getInitialTab = () => {
        if (typeof window !== 'undefined') {
            // Prioritizovat hash před query parametry
            const hash = window.location.hash.replace(/^#\/?/, '').split('/')[0];
            if (hash && urlToTab[hash]) {
                return urlToTab[hash];
            }
            // Fallback na query parametr (pro kompatibilitu)
            const params = new URLSearchParams(window.location.search);
            const tabParam = params.get('tab');
            if (tabParam && urlToTab[tabParam]) {
                return urlToTab[tabParam];
            }
            // Pokud je tab=uzivatele nebo podobné, ignorovat a použít hash
            // (uzivatele není v urlToTab, takže se přeskočí)
        }
        return 2; // Default: Meeting rooms
    };

    const [tabSelected, setTabSelected] = useState(getInitialTab);
    const orgName = String(props.cred?.organizationName || '').toLowerCase();
    const orgId = String(props.cred?.cOrganization_id || '').toUpperCase();
    const showLiveCameras =
        orgName.includes('nymburk') ||
        orgId === '82BB6005-2C25-4EB9-A6CC-DB8BFB4A3C70' ||
        orgId === '2E5A043D-B31B-4854-8533-7E5571FB90B5';

    // Hide "Meeting rooms" tab if org has no displays (device_group=1).
    // Default null = neznámo, ukaž (= optimistický render dokud nedotáhneme).
    const [hasDisplays, setHasDisplays] = useState(null);
    useEffect(() => {
        const orgIdRaw = props.cred?.cOrganization_id;
        if (!orgIdRaw) { setHasDisplays(false); return; }
        let cancelled = false;
        (async () => {
            try {
                const resp = await axios.get(`${path}/getDisplaysbyOrg/${orgIdRaw}`);
                if (cancelled) return;
                const list = Array.isArray(resp.data) ? resp.data : [];
                setHasDisplays(list.length > 0);
            } catch (_) {
                if (!cancelled) setHasDisplays(false);
            }
        })();
        return () => { cancelled = true; };
    }, [props.cred?.cOrganization_id]);

    // Update URL when tab changes (zachovat query params pro kiosk/displej, ale odstranit tab= parametr)
    const updateUrl = (tab) => {
        if (typeof window !== 'undefined') {
            const tabName = tabToUrl[tab];
            if (tabName) {
                // Odstranit tab= parametr z query string, zachovat ostatní parametry (např. id, room, orgID)
                const params = new URLSearchParams(window.location.search);
                params.delete('tab'); // Odstranit starý tab parametr
                const search = params.toString();
                const newUrl = `${window.location.pathname}${search ? `?${search}` : ''}#${tabName}`;
                window.history.pushState({ tab }, '', newUrl);
            }
        }
    };

    // Load tab from URL on mount – nepřepisovat URL na #meeting-rooms, pokud je prázdná (nech uživatele na root)
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const initialTab = getInitialTab();
            setTabSelected(initialTab);
            const currentHash = (window.location.hash || '').replace(/^#\/?/, '').split('/')[0];
            const expectedHash = tabToUrl[initialTab];
            // Přidat hash jen když už nějaký je a neshoduje se (např. uživatel přišel na #slideshow)
            if (currentHash && currentHash !== expectedHash) {
                updateUrl(initialTab);
            }
        }
    }, []);

    // Handle browser back/forward buttons and hash changes
    useEffect(() => {
        const handlePopState = () => {
            const tab = getInitialTab();
            setTabSelected(tab);
        };
        const handleHashChange = () => {
            const tab = getInitialTab();
            setTabSelected(tab);
        };
        window.addEventListener('popstate', handlePopState);
        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('popstate', handlePopState);
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    const changeTab_handler = (event) => {
        const temp = parseInt(event.target.value, 10);
        setTabSelected(temp);
        updateUrl(temp);
    }
    const menuButtons = [];
    if (props.cred.pravo_slideshow == 1) menuButtons.push({ value: 1, label: "Kiosk slideshow" });
    if (props.cred.pravo_diplomat == 1) menuButtons.push({ value: 4, label: "Kiosk slideshow" });
    // Meeting rooms má smysl jen když org má aspoň 1 displej (device_group=1).
    // Dokud se počet displejů nedotáhne (hasDisplays === null), tab ukaž
    // (optimistický render — zabraňuje krátkému poskočení layoutu).
    if (props.cred.pravo_calendar == 1 && hasDisplays !== false) {
        menuButtons.push({ value: 2, label: "Meeting rooms" });
    }
    if (showLiveCameras) menuButtons.push({ value: 8, label: "Live cameras" });
    if (props.cred.pravo_weekSlideshow == 1) menuButtons.push({ value: 0, label: "Menu screen" });
    if (props.cred.pravo_vienna == 1) menuButtons.push({ value: 6, label: "Explore" });
    if (props.cred.pravo_vienna == 1) menuButtons.push({ value: 7, label: "Text edit" });
    menuButtons.push({ value: 5, label: "Users / Displays" }); // always last

    const renderMenuButtons = () => menuButtons.map((item, idx) => (
        <span key={`${item.value}-${idx}`} style={{ display: 'inline-flex', alignItems: 'center' }}>
            {idx > 0 && <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }}/>}
            <Button onClick={changeTab_handler} value={item.value} color={"primary"} variant={tabSelected == item.value ? "contained" : "text"} sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' }, padding: { xs: '4px 8px', sm: '6px 16px' } }}>
                {item.label}
            </Button>
        </span>
    ));

    return <div className={classes.flexContainer}>
        <div className={classes.header}>
            <div className={classes.logo}>
                <img src={`${path}/admin/${encodeURI((props.cred.logopath || '').replace(/\\/g, '/'))}`} alt={`${props.cred.organizationName} logo`}/>
            </div>
            <div className={`${classes.menu} ${classes.menuDesktop}`}>
                {renderMenuButtons()}
            </div>
            <div className={classes.user}>
                <span>{props.cred.username}</span>
                <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', sm: 'flex' } }} />
                <Tooltip title="Log out">
                    <IconButton
                        aria-label="Log out"
                        onClick={() => props.logOut()}
                        size={isMobile ? 'small' : 'medium'}
                    >
                        <LogoutIcon />
                    </IconButton>
                </Tooltip>
            </div>
        </div>
        <div className={`${classes.menu} ${classes.menuMobile}`}>
            {renderMenuButtons()}
        </div>
        <div className={classes.body}>
            {
                tabSelected == 0 ? <Menu cred={props.cred}/>:
                    tabSelected == 1 ? <SpecOffer cred={props.cred}/>:
                        tabSelected == 2 ? <Calendar cred={props.cred}/>:
                            tabSelected == 3 ? <Vienna_slide cred={props.cred}/>:
                                tabSelected == 4 ? <Diplomat_slide cred={props.cred}/>:
                                    tabSelected == 6 ? <Vienna_explore cred={props.cred}/>:
                                        tabSelected == 7 ? <Vienna_text cred={props.cred}/>:
                                            tabSelected == 8 ? <LiveCameras cred={props.cred}/>:
                                            tabSelected == 5 ? <UsersDisplays cred={props.cred}/>:
                        <Users cred={props.cred}/>
            }
        </div>
        <div className={classes.footer}>
            <p>Copyright &#169; 2026 Computer System Group a.s.</p>
        </div>


    </div>
}

export default Dashboard